import request from '@/config/axios'

//是否启用CA
export function caFlag() {
    return request({
        url: `/doctor/ca_flag`,
        method: 'get',
    })
}

//验证码
export function getCaptcha() {
    return request({
        url: `/doctor/captcha`,
        method: 'get',
    })
}

// 登录
export function Login(data) {
    return request({
        url: `/doctor/login`,
        method: 'post',
        data
    })
}

//ca登录
export function CA_Login(data) {
    return request({
        url: `/doctor/ca_login`,
        method: 'post',
        data
    })
}

//获取登录人信息
export function getCA_Token(query) {
    return request({
        url: `/doctor/ca_token_info`,
        method: 'get',
        params: query
    })
}

// 登录人信息
export function getInfo() {
    return request({
        url: `/doctor/get`,
        method: 'get'
    })
}

export function updateSelfSignFlag(data) {
    return request({
        url: `/doctor/doctor/update_self_sign`,
        method: 'post',
        data
    })
}

//药房内药品分类
export function Medicinal(data) {
    return request({
        url: `/doctor/pharmacy_drug/drug_category`,
        method: 'get',
        data
    })
}

//搜索药品
export function Medicinal_Search(query) {
    return request({
        url: `/doctor/pharmacy_drug/drug/search`,
        method: 'get',
        params: query
    })
}

//库存
export function Medicinal_Stock(data) {
    return request({
        url: `/pharmacy_drug/stock`,
        method: 'get',
        data
    })
}

//预约列表
export function orderList(query, isSilent = false) {
    return request({
        url: `/doctor/reverse_prescription_order/list`,
        method: 'get',
        params: query,
        silent: isSilent
    })
}

//结束问诊
export function overOrder(data) {
    return request({
        url: `/doctor/reverse_prescription_order/over`,
        method: 'post',
        data
    })
}

//接诊
export function Treated(data) {
    return request({
        url: `/doctor/reverse_prescription_order/start`,
        method: 'post',
        data
    })
}

export function refuse(data) {
    return request({
        url: `/doctor/reverse_prescription_order/refuse`,
        method: 'post',
        data
    })
}

//诊断列表
export function sicknessList(query) {
    return request({
        url: `/doctor/sickness/list`,
        method: 'get',
        params: query
    })
}

//发送消息
export function msgUp(data) {
    return request({
        url: `/doctor/im/save`,
        method: 'post',
        data
    })
}

//消息列表
export function msgList(query, isSilent = false) {
    return request({
        url: `/doctor/im/list`,
        method: 'get',
        params: query,
        silent: isSilent
    })
}

//开处方
export function Extraction(data) {
    return request({
        url: `/doctor/prescription/save`,
        method: 'post',
        data
    })
}

//处方列表
export function prescriptionList(query, isSilent = false) {
    return request({
        url: `/doctor/prescription/list`,
        method: 'get',
        params: query,
        silent: isSilent
    })
}

//处方搜索
export function prescriptionSearch(query) {
    return request({
        url: `/doctor/prescription/get/order_id`,
        method: 'get',
        params: query
    })
}

//字典
export function dictDataList(query) {
    return request({
        url: `/doctor/sickness/search`,
        method: 'get',
        params: query
    })
}

//处方审核
export function Examine(data) {
    return request({
        url: `/doctor/prescription/audit`,
        method: 'post',
        data
    })
}

//处方撤销
export function Cancel(data) {
    return request({
        url: `/doctor/prescription/discard`,
        method: 'post',
        data
    })
}

//修改密码
export function ChangepassWord(data) {
    return request({
        url: `/doctor/update/password`,
        method: 'post',
        data
    })
}

//登出
export function LoginOut(data) {
    return request({
        url: `/doctor/logout`,
        method: 'post',
        data
    })
}

//下载
export function downLoadPdf(data) {
    return request({
        url: `/doctor/download/base64`,
        method: 'post',
        data
    })
}

//上传图片
export function imgDownLoad(data) {
    return request({
        url: `/doctor/download/base64`,
        method: 'post',
        data
    })
}

//下载图片
export function imgUpload(data) {
    return request({
        url: `/doctor/upload/base64`,
        method: 'post',
        data
    })
}

//订单列表
export function orderSelfList(query) {
    return request({
        url: `/doctor/reverse_prescription_order/self/list`,
        method: "get",
        params: query,
    });
}

//订单详情
export function detailsData(query) {
    return request({
        url: `/doctor/reverse_prescription_order/details`,
        method: "get",
        params: query,
    });
}


//预约
export function order(data) {
    return request({
        url: `/doctor/reverse_prescription_order/order`,
        method: 'post',
        data
    })
}

//慢特病查询
export function queryPsnOpspReg(query) {
    return request({
        url: `/doctor/prescription/query_psn_opsp_reg`,
        method: "get",
        params: query,
    })
}

//住院查询
export function queryInHospInfo(query) {
    return request({
        url: `/doctor/prescription/query_in_hosp_info`,
        method: "get",
        params: query,
    })
}

//快捷语模板列表
export function getQuickReplyTemplates(query) {
    return request({
        url: `/doctor/im_template/list`,
        method: "get",
        params: query,
    })
}


//获取病历
export function getMedicalRecordPre(query) {
    return request({
        url: `/doctor/medical_record/medical_record_pre`,
        method: "get",
        params: query,
    })
}

//保存病历
export function saveMedicalRecord(data) {
    return request({
        url: `/doctor/medical_record/medical_record`,
        method: "post",
        data
    })
}

// 病历列表
export function getMedicalRecordsList(query) {
    return request({
        url: `/doctor/medical_record/list`,
        method: "get",
        params: query,
    })
}

// 病历详情
export function getMedicalRecordsDetails(query) {
    return request({
        url: `/doctor/medical_record/get/medical_record_order_number`,
        method: "get",
        params: query,
    })
}

//下载病历
export function downLoadMedicalRecord(data) {
    return request({
        url: `/doctor/medical_record/download`,
        method: "post",
        data
    })
}
// 视频通话
export function getDoctorVideoInfo(data) {
    return request({
        url: `/doctor/video/call`,
        method: "post",
        data
    })
}